import { render, staticRenderFns } from "./MailRequests.vue?vue&type=template&id=5bdb7310"
import script from "./MailRequests.vue?vue&type=script&lang=js"
export * from "./MailRequests.vue?vue&type=script&lang=js"
import style0 from "./MailRequests.vue?vue&type=style&index=0&id=5bdb7310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports